import gql from 'graphql-tag';

const getPingStatusQuery = gql`
  query featureFlagsQuery {
    pingFeatureFlagStatus {
      active
    }
  }
`;

export default getPingStatusQuery;
